export const availableCountries = [
  'af', // Afghanistan (+93)
  'as', // American Samoa (+1684)
  'ag', // Antigua and Barbuda (+1268)
  'au', // Australia/Cocos/Christmas Island (+61)
  'cc', // Australia/Cocos/Christmas Island (+61)
  'cx', // Australia/Cocos/Christmas Island (+61)
  'at', // Austria (+43)
  'bs', // Bahamas (+1242)
  'bb', // Barbados (+1246)
  'be', // Belgium (+32)
  'bm', // Bermuda (+1441)
  'br', // Brazil (+55)
  'cm', // Cameroon (+237)
  'ca', // Canada (+1)
  'ky', // Cayman Islands (+1345)
  'cl', // Chile (+56)
  'cn', // China (+86)
  'co', // Colombia (+57)
  'cz', // Czech Republic (+420)
  'dk', // Denmark (+45)
  'do', // Dominican Republic (+1809)
  'eg', // Egypt (+20)
  'et', // Ethiopia (+251)
  'fi', // Finland/Aland Islands (+358)
  'ax', // Finland/Aland Islands (+358)
  'fr', // France (+33)
  'de', // Germany (+49)
  'gr', // Greece (+30)
  'gu', // Guam (+1671)
  'gg', // Guernsey/Jersey (+44)
  'je', // Guernsey/Jersey (+44)
  'hk', // Hong Kong (+852)
  'in', // India (+91)
  'ie', // Ireland (+353)
  'im', // Isle of Man (+44)
  'it', // Italy (+39)
  'jm', // Jamaica (+1876, +1658)
  'jp', // Japan (+81)
  'xk', // Kosovo (+383)
  'kr', // Korea Republic of (+82)
  'lr', // Liberia (+231)
  'lu', // Luxembourg (+352)
  'mw', // Malawi (+265)
  'mt', // Malta (+356)
  'mx', // Mexico (+52)
  'mc', // Monaco (+377)
  'ma', // Morocco/Western Sahara (+212)
  'eh', // Morocco/Western Sahara (+212)
  'mm', // Myanmar (+95)
  'na', // Namibia (+264)
  'nl', // Netherlands (+31)
  'nz', // New Zealand (+64)
  'mp', // Northern Mariana Islands (+1670)
  'no', // Norway (+47)
  'pk', // Pakistan (+92)
  'py', // Paraguay (+595)
  'pe', // Peru (+51)
  'ph', // Philippines (+63)
  'pl', // Poland (+48)
  'pt', // Portugal (+351)
  'pr', // Puerto Rico (+1787)
  'mk', // Republic of North Macedonia (+389)
  'ro', // Romania (+40)
  'ru', // Russia/Kazakhstan (+7)
  'kz', // Russia/Kazakhstan (+7)
  'sa', // Saudi Arabia (+966)
  'rs', // Serbia (+381)
  'sg', // Singapore (+65)
  'so', // Somalia (+252)
  'za', // South Africa (+27)
  'es', // Spain (+34)
  'lc', // St Lucia (+1758)
  'se', // Sweden (+46)
  'ch', // Switzerland (+41)
  'tt', // Trinidad and Tobago (+1868)
  'nc', // Turkish Republic of Northern Cyprus (+90)
  'tr', // Turkiye (+90)
  'tc', // Turks and Caicos Islands (+1649)
  'ua', // Ukraine (+380)
  'ae', // United Arab Emirates (+971)
  'gb', // United Kingdom (+44)
  'us', // United States (+1)
  'vu', // Vanuatu (+678)
  've', // Venezuela (+58)
  'vg', // Virgin Islands, British (+1284)
  'vi', // Virgin Islands, U.S. (+1340)
];

export const availableCountriesMap = Object.fromEntries(
  availableCountries.map((code) => [code, true]),
);
